<h1 mat-dialog-title>Data On Demand Layout Designer</h1>
<div mat-dialog-content style="height: 600px">
  <div class="row" *ngIf="errorMessage" style="margin-top: 10px; margin-bottom: 10px">
    <div class="col-md-12 alert alert-danger">{{errorMessage}}</div>
  </div>
  <mat-tab-group>
    <mat-tab label="General Settings">
      <form class="standard-form full-width">
        <mat-form-field class="full-width">
          <mat-label>Layout Name</mat-label>
          <input matInput name="result.dodLayout.name" [(ngModel)]="result.dodLayout.name" />
        </mat-form-field>
        <mat-form-field class="full-width">
          <mat-label>Subscription</mat-label>
          <mat-select [(value)]="selectedSubscriptionId">
            <mat-option *ngFor="let subHeader of dod_subscriptions" [value]="subHeader.subscriptionId">
              {{ subHeader.subscriptionName }} - {{ subHeader.organizationName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
      <app-share-editor *ngIf="isOwner" [allowReadOnly]="true" [allowModify]="true" [(ngModel)]="shareState" [avaialbleSubscriptions]="dod_subscriptions"></app-share-editor>
    </mat-tab>

    <mat-tab label="Endpoint Settings">
      <mat-card class="tight-card">
        <mat-card-title>Endpoints</mat-card-title>
        <mat-card-content>
          <div class="row">
            <div class="col-md-10">
              <mat-form-field class="full-width">
                <mat-select placeholder="Add Endpoint" #endPointToAdd>
                  <mat-option *ngFor="let ep of allEndPoints" [value]="ep">{{ep.title}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-2" style="margin-top: 15px">
              <button mat-raised-button class="piButton" (click)="addEndPoint(endPointToAdd.value); endPointToAdd.value = null">Add</button>
            </div>
          </div>
          <div class="row" *ngFor="let ep of result.dodLayout.endPoints; let i = index" style="margin-top: 10px; border-bottom: 1px solid #ccc; padding-bottom: 5px">
            <div class="col-md-2" style="margin-top: 10px">
              <a href="#" (click)="configureEndPoint(i)"><span class="fas fa-cog" title="Configure Endpoint"></span></a>&nbsp;
              <a href="#" (click)="removeEndPoint(i)"><span class="fas fa-trash" title="Remove Endpoint"></span></a>
            </div>
            <div class="col-md-8" style="margin-top: 10px">
              {{getEndPointTitle(ep.dodEndPointId)}}
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-tab>

    <mat-tab label="Output Settings">
      <br />
      <mat-card>
        <mat-card-title>
          <form class="standard-form full-width">
            <mat-form-field class="full-width">
              <mat-label>File Type</mat-label>
              <mat-select name="result.dodLayout.fileTypeId" [(ngModel)]="result.dodLayout.fileTypeId">
                <mat-option [value]="0">CSV</mat-option>
                <mat-option [value]="1">JSON</mat-option>
                <mat-option [value]="2">PARQUET</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Destination Type</mat-label>
              <mat-select [(value)]="destinationId">
                <mat-option [value]="0">Email</mat-option>
                <mat-option [value]="1">SFtp</mat-option>
                <mat-option [value]="2">Azure Blob</mat-option>
                <mat-option [value]="3">AWS S3</mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </mat-card-title>
        <mat-card-content>
          <ng-container *ngIf="destinationId == 0">
            <form class="standard-form full-width">
              <mat-form-field class="full-width">
                <mat-label>Notification Email</mat-label>
                <input matInput name="results.dodLayout.notificationEmail" [(ngModel)]="result.dodLayout.notificationEmail" />
              </mat-form-field>
              <!--<mat-form-field class="full-width">
                <mat-label>Email Address</mat-label>
                <input matInput name="emailConfig.emailAddress" [(ngModel)]="emailConfig.emailAddress" />
              </mat-form-field>-->
            </form>
          </ng-container>
          <ng-container *ngIf="destinationId == 1">
            <form class="standard-form full-width">
              <mat-form-field class="full-width">
                <mat-label>Notification Email</mat-label>
                <input matInput name="results.dodLayout.notificationEmail" [(ngModel)]="result.dodLayout.notificationEmail" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Host</mat-label>
                <input matInput name="sftpConfig.host" [(ngModel)]="sftpConfig.host" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Port</mat-label>
                <input matInput type="number" name="sftpConfig.port" [(ngModel)]="sftpConfig.port" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Username</mat-label>
                <input matInput name="sftpConfig.userName" [(ngModel)]="sftpConfig.userName" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Password / Passphrase</mat-label>
                <input matInput name="sftpConfig.password" [(ngModel)]="sftpConfig.password" />
                <mat-hint>Used as passphrase if Private Key is provided</mat-hint>
              </mat-form-field>
              <br />
              <mat-form-field class="full-width">
                <mat-label>Private Key (PPK content)</mat-label>
                <textarea matInput name="sftpConfig.privateKey" [(ngModel)]="sftpConfig.privateKey" rows="5"></textarea>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Remote Path</mat-label>
                <input matInput name="sftpConfig.path" [(ngModel)]="sftpConfig.path" />
              </mat-form-field>
              <ng-container>
                <mat-checkbox name="sftpConfig.folderPerEndPoint" [(ngModel)]="sftpConfig.folderPerEndPoint">
                  Generate Sub-Folder for each end point?
                </mat-checkbox>
              </ng-container>
              <br />
            </form>
          </ng-container>
          <ng-container *ngIf="destinationId == 2">
            <form class="standard-form full-width">
              <mat-form-field class="full-width">
                <mat-label>Notification Email</mat-label>
                <input matInput name="results.dodLayout.notificationEmail" [(ngModel)]="result.dodLayout.notificationEmail" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Connection String</mat-label>
                <input matInput name="azureConfig.connectionString" [(ngModel)]="azureConfig.connectionString" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Container</mat-label>
                <input matInput name="azureConfig.containerName" [(ngModel)]="azureConfig.containerName" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Path</mat-label>
                <input matInput name="azureConfig.path" [(ngModel)]="azureConfig.path" />
              </mat-form-field>
              <ng-container>
                <mat-checkbox name="azureConfig.folderPerEndPoint" [(ngModel)]="azureConfig.folderPerEndPoint">
                  Generate Sub-Folder for each end point?
                </mat-checkbox>
              </ng-container>
            </form>
          </ng-container>
          <ng-container *ngIf="destinationId == 3">
            <form class="standard-form full-width">
              <mat-form-field class="full-width">
                <mat-label>Notification Email</mat-label>
                <input matInput name="results.dodLayout.notificationEmail" [(ngModel)]="result.dodLayout.notificationEmail" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Access Key</mat-label>
                <input matInput name="awsConfig.accessKey" [(ngModel)]="awsConfig.accessKey" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Secret Key</mat-label>
                <input matInput name="awsConfig.secretKey" [(ngModel)]="awsConfig.secretKey" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Region</mat-label>
                <input matInput name="awsConfig.region" [(ngModel)]="awsConfig.region" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Bucket</mat-label>
                <input matInput name="awsConfig.bucketName" [(ngModel)]="awsConfig.bucketName" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Path</mat-label>
                <input matInput name="awsConfig.path" [(ngModel)]="awsConfig.path" />
              </mat-form-field>
              <ng-container>
                <mat-checkbox name="awsConfig.folderPerEndPoint" [(ngModel)]="awsConfig.folderPerEndPoint">
                  Generate Sub-Folder for each end point?
                </mat-checkbox>
              </ng-container>
            </form>
          </ng-container>
        </mat-card-content>
      </mat-card>
    </mat-tab>

    <mat-tab label="Filters">
      <mat-form-field style="width: 100%">
        <mat-label>Filtering Source</mat-label>
        <mat-select [(value)]="filteringSource">
          <mat-option [value]="-1">Direct Filter</mat-option>
          <ng-container *ngFor="let preFilter of data.preFilters">
            <mat-option [value]="preFilter.preFilterId">PreFilter: {{preFilter.name}}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
      <div class="row">
        <div class="col-md-6" *ngIf="filteringSource === -1 || hasEndPointSpecificFilters()">
          <button mat-raised-button class="piButton full-width" (click)="editDirectFilter()">Edit Direct Filter</button>
        </div>
        <div class="col-md-6" *ngIf="filteringSource !== -1">
          <button mat-raised-button class="piButton full-width" (click)="copyPreFilterToDirect()">Copy PreFilter to Direct Filter</button>
        </div>
      </div>
      <ng-container *ngIf="filteringSource === -1">
        <div class="row" style="margin-top: 10px">
          <div class="col-md-6">
            <input #fileInput type="file" id="inputFile" (change)="handleFileInput($event.target.files)" style="display: none" />
            <button mat-raised-button class="piButton full-width" (click)="fileInput.click()">Upload Filter Template</button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="errorMessages && errorMessages.length > 0">
        <div *ngFor="let errorMessage of errorMessages">
          <mat-error>{{ errorMessage }}</mat-error>
        </div>
      </ng-container>
      <ng-container *ngIf="statusMessage">
        <b>{{ statusMessage }}</b>
      </ng-container>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onSaveLayout()">Save Layout</button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>
</div>
